import './src/styles/global.css'
import './src/components/styles/boxBag.css'
import React from 'react'
import WrapRootElement from './src/components/wrap-root-element'
import { loadAnalytics, trackPageView } from './src/utils/analytics'

export const wrapRootElement = ({ element }) => (
    <WrapRootElement>
        {element}
    </WrapRootElement>
)

export const onClientEntry = () => {
    loadAnalytics()
}

export const onRouteUpdate = ({ location }) => {
    window.setTimeout(() => trackPageView(location), 0)
}
